import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import * as moment from 'moment';

import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class ContractsProductValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
    validate(contracts: ContractItem[], validationArguments: ValidationArguments) {
        this.message = '';
        const contractGroupSupp: { [id: string]: ContractItem[]; } = {};
        for (let contract of contracts) {
			if (contract.supplierId) {
				const key = contract.supplierId.toString();
				if (contractGroupSupp[key] == null) {
					contractGroupSupp[key] = [];
				}
				if (contractGroupSupp[key].find(x => x == contract) == null) {
					contractGroupSupp[key].push(contract);
				}
            }
		}

        for (let prop in contractGroupSupp) {
            let contractBySupp: ContractItem[] = contractGroupSupp[prop];
            let contractDateBands: ContractRangeDateItem[] = [];
            for (let contract of contractBySupp) {
                if (contract.dateBands) {
					for (let db of contract.dateBands) {
						contractDateBands.push(db)
					}
                }
			}

			if (!this.validatedDateBands(contractDateBands)) {
				return false;
			}
		}

        return true;
	}

	validatedDateBands(contractDateBands: ContractRangeDateItem[]) {
		if (contractDateBands == null || contractDateBands.length == 0)
			return true;
		const result: boolean[] = [];
		contractDateBands.forEach((request, index) => {
			let fromResult: ContractRangeDateItem = contractDateBands.find(y => y != request && moment.utc(y.serviceDateFrom).startOf('day').toDate() <= moment.utc(request.serviceDateFrom).startOf('day').toDate() && moment.utc(y.serviceDateTo).startOf('day').toDate() >= moment.utc(request.serviceDateFrom).startOf('day').toDate());
			let toResult: ContractRangeDateItem = contractDateBands.find(y => y != request && moment.utc(y.serviceDateFrom).startOf('day').toDate() <= moment.utc(request.serviceDateTo).startOf('day').toDate() && moment.utc(y.serviceDateTo).startOf('day').toDate() >= moment.utc(request.serviceDateTo).startOf('day').toDate());
			if (fromResult != null) {
				let fromBookingResult = moment.utc(fromResult.bookingDateFrom).startOf('day').toDate() <= moment.utc(request.bookingDateFrom).startOf('day').toDate() && moment.utc(fromResult.bookingDateTo).startOf('day').toDate() >= moment.utc(request.bookingDateFrom).startOf('day').toDate();
				let toBookinResult = moment.utc(fromResult.bookingDateFrom).startOf('day').toDate() <= moment.utc(request.bookingDateTo).startOf('day').toDate() && moment.utc(fromResult.bookingDateTo).startOf('day').toDate() >= moment.utc(request.bookingDateTo).startOf('day').toDate();
				if (fromBookingResult || toBookinResult) {
					this.message = `There is overlap between date band with service date from : ${request.serviceDateFromText} and service date to : ${request.serviceDateToText} and the others contracts ranges of dates <br />`;
					result.push(false);
				}
			}

			if (toResult != null) {
				let fromBookingResult = moment.utc(toResult.bookingDateFrom).startOf('day').toDate() <= moment.utc(request.bookingDateFrom).startOf('day').toDate() && moment.utc(toResult.bookingDateTo).startOf('day').toDate() >= moment.utc(request.bookingDateFrom).startOf('day').toDate();
				let toBookinResult = moment.utc(toResult.bookingDateFrom).startOf('day').toDate() <= moment.utc(request.bookingDateTo).startOf('day').toDate() && moment.utc(toResult.bookingDateTo).startOf('day').toDate() >= moment.utc(request.bookingDateTo).startOf('day').toDate();
				if (fromBookingResult || toBookinResult) {
					this.message = `There is overlap between date band with service date from : ${request.serviceDateFromText} and service date to : ${request.serviceDateToText} and the others contracts ranges of dates <br />`;
					result.push(false);
				}
			} else {
				result.push(true);
			}
		});
		return result.every(x => x);
	}

    defaultMessage(args: ValidationArguments) {
        return this.message;
    }
}



// WEBPACK FOOTER //
// ./src/core/customValidator/contracts-product-validator.ts